import type { Icon, IconProps } from "@phosphor-icons/react";

import { useLocaleInfo } from "@/hooks/useLocaleInfo";

export function addRtlSupport(
  IconComponent: Icon,
): React.ComponentType<IconProps> {
  const PatchedIcon = (props: IconProps) => {
    const { dir } = useLocaleInfo();

    return <IconComponent mirrored={dir === "rtl"} {...props} />;
  };

  PatchedIcon.displayName = IconComponent.displayName;

  return PatchedIcon;
}
